import { IStageRepositoryResponse } from "@/core/repositories/lookup";
import { LookupRepository } from "@/infrastructure/repositories/lookup";

export class GetStageUseCase {
    constructor(private readonly lookupRepository: LookupRepository) {}
    
    async execute(): Promise<IStageRepositoryResponse> {
        return this.lookupRepository.getStages();
    }
}